import Carousel from "../Carousel/Carousel";
import styles from "./Cricket.module.css";

const cricketData = [
  {
    id: 1,
    img: require("../../assets/images/cricket-img-1.png"),
    alt: "",
  },
  {
    id: 2,
    img: require("../../assets/images/cricket-img-2.png"),
    alt: "",
  },
  {
    id: 3,
    img: require("../../assets/images/cricket-img-3.png"),
    alt: "",
  },
  {
    id: 4,
    img: require("../../assets/images/cricket-img-4.png"),
    alt: "",
  },
];

const Cricket = () => {
  return <Carousel title="Cricket" data={cricketData} />;
};

export default Cricket;
